export const getSaveLabelButtonByIntegrationType = (type, isConnected) => {
  if (type === 'stripe' && !isConnected) {
    return 'Conectar con Stripe'
  }

  return 'Guardar cambios'
}

export const getSaveLoadingLabelButtonByIntegrationType = (type, isConnected) => {
  if (type === 'stripe' && !isConnected) {
    return 'Conectando con Stripe'
  }

  return 'Guardando cambios'
}
